export default "__VITE_ASSET__BVGk15H8__"